import { gql } from '@zenbusiness/application-commons-graphql';

export const PRODUCT_CARDS_QUERY = gql`
  query ProductCardsV2($filter: ProductCardsV2Filter!) {
    productCardsV2(filter: $filter) {
      cards {
        uuid
        titleKey
        descriptionKey
        rank
        imagePath
        categoryUuids
        serviceCode
        primaryPath
        primaryExternal
        partnerImagePath
      }
      categories {
        uuid
        titleKey
        rank
        isActive
      }
    }
  }
`;
